import React from 'react';
import './logo.scss';

var Logo = ({appKey, message}) => {
  return (
    <div className='logo'>
      {message && (
        <div className='message'>{message}</div>
      )}
      <div className='app-name'>
        stories
      </div>
      <div className='company-name'>
        <span>symbolic</span>
        <span> frameworks</span>
      </div>
    </div>
  )
};

export default Logo;
